export const environment = {
  endpoint: 'https://api-momentify.abostudio.mx/',
  production: false,
  storage: 'momentos',
  title: 'Momentos',
};
